/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ICD10Diagnosis from './icd-10-diagnosis';
import ICD10DiagnosisDetail from './icd-10-diagnosis-detail';
import ICD10DiagnosisUpdate from './icd-10-diagnosis-update';
import ICD10DiagnosisDeleteDialog from './icd-10-diagnosis-delete-dialog';

const ICD10DiagnosisRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ICD10Diagnosis />} />
    <Route path="new" element={<ICD10DiagnosisUpdate />} />
    <Route path=":id">
      <Route index element={<ICD10DiagnosisDetail />} />
      <Route path="edit" element={<ICD10DiagnosisUpdate />} />
      <Route path="delete" element={<ICD10DiagnosisDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ICD10DiagnosisRoutes;
